import React, { useState, useEffect } from "react";

const CountdownTimer = ({ initialTime, setCall }) => {
  // useEffect(()=>{
  //   clearInterval(timer)
  // })
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const call =()=>{
    setCall(true)
  }
  const callF =()=>{
    setCall(false)
  }
  useEffect(() => {
    if (timeLeft <= 0){
      setTimeLeft(initialTime)
      callF()

    }
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, initialTime]);

  // Format the time in MM:SS format
  const formatmin = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}`;
  };
  const formatsec = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(seconds).padStart(2, "0")}`;
  };
  const formatTIme = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };
  

  useEffect(()=>{
    if(timeLeft === 5){
      call()
    }
  },[timeLeft])
  return (
    <div>
        <p className="font-semibold flex justify-center items-center text-center px-2 pr-px">
          <span className="bg-[#ff7220] rounded-[5px] text-center text-2xl text-white px-1">{formatmin(timeLeft)}</span>
          <p className='mx-1 text-[#ff7220]'>:</p>
          <span className="bg-[#ff7220] rounded-[5px] text-center text-2xl text-white px-1">{formatsec(timeLeft)}</span>
        </p>
    </div>
  );
};

// Usage
const Timer = ({ setCall, activeT }) => {
  return (
    <div>
      <CountdownTimer initialTime={activeT.time} setCall={setCall}/> {/* Countdown from Selected time */}
    </div>
  );
};

export default Timer;
